// Montant d'un paiement PAYGo rattaché à la recette affichée.
//
// Depuis le pointage partiel (domainModel, income_links), un paiement peut être réparti
// sur plusieurs recettes : son montant total (`money`) n'est plus ce qu'il apporte à
// celle-ci. domainModel sert cette part dans `income_amount`, calculée pour la recette
// demandée. Un domainModel antérieur ne la sert pas : on retombe alors sur `money`, qui
// était exact tant qu'un paiement n'était pointé que sur une seule recette.
export function incomePaymentAmount(pay) {
    if (!pay) return 0;
    const part = pay.income_amount;
    if (typeof part === "number" && Number.isFinite(part)) return part;
    const money = Number(pay.money);
    return Number.isFinite(money) ? money : 0;
}

// Vrai quand le paiement n'est rattaché à cette recette que pour une partie de son montant.
export function isPartialIncomePayment(pay) {
    if (!pay) return false;
    const money = Number(pay.money);
    return Number.isFinite(money) && incomePaymentAmount(pay) < money - 0.01;
}

// Identifiants 8000 d'un paiement lié, dans l'ordre où on les cherche côté 8000 :
// l'identifiant du paiement, la box, puis la référence de transaction de l'opérateur.
// Les champs absents sont omis ; domainModel ne sert pas le nom du payeur à la 5000,
// ce sont donc ces identifiants qui permettent de retrouver le paiement.
export function incomePaymentRefs(pay) {
    if (!pay) return [];
    return [
        { label: "ID 8000", value: pay.paymentID },
        { label: "Box", value: pay.boxId },
        { label: "Transaction", value: pay.transactionId },
    ].filter(ref => typeof ref.value === "string" && ref.value.trim() !== "");
}

// Total rattaché à la recette : somme des parts, pas des montants de paiement.
export function incomePaymentsTotal(payments) {
    return (payments || []).reduce((sum, pay) => sum + incomePaymentAmount(pay), 0);
}
